import { NgModule } from '@angular/core';
import { httpInterceptorProviders } from './http-interceptors';
import { AuthorizationGuard } from './guards/authorization.guard';

@NgModule({
  declarations: [],
  providers: [httpInterceptorProviders, AuthorizationGuard],
})
export class CoreModule {}
